import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { makeStyles, IconButton } from '@material-ui/core';
import RemoveIcon from '@material-ui/icons/Close';
import { getAllIndexes } from '../../../../../../../helpers';

const useStyles = makeStyles(() => ({
  tableItem: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

const CptEndCheckbox = ({
  form,
  backendErrors,
  cpts,
  setCpts,
  setErrors,
  validateField,
  index,
}) => {
  const classes = useStyles();

  const updateErrors = useCallback(async (index) => {
    const serviceErrors = backendErrors?.ispConfiguration?.services;

    const newErrors = {
      ...backendErrors,
      ispConfiguration: {
        ...backendErrors?.ispConfiguration,
        services: serviceErrors
          ? [...serviceErrors.slice(0, index), ...serviceErrors.slice(index + 1)]
          : [],
      },
    };

    await setErrors(newErrors);
  }, [backendErrors, setErrors]);

  const updateDuplicatedErrors = useCallback(async (newCpt, prevValue) => {
    const indexesOfSameCptCode = getAllIndexes(newCpt.map(i => i.cptCode), prevValue);
    if (indexesOfSameCptCode.length === 1) {
      await validateField(`ispConfiguration.services[${indexesOfSameCptCode[0]}].cptCode`);
    }
  }, [validateField]);

  const updateCpts = useCallback((index) => {
    setCpts(prevCpts => {
      const newCpts = prevCpts.length > 1
        ? [...prevCpts.slice(0, index), ...prevCpts.slice(index + 1)]
        : [];

      return newCpts.map((item, i) => ({
        ...item,
        index: i,
      }));
    });
  }, [setCpts]);

  const onDismiss = useCallback(async (index, form) => {
    const services = form.values?.ispConfiguration?.services;
    if (!services) return;

    const prevValue = services[index]?.cptCode;
    const currentErrorObj = backendErrors?.ispConfiguration?.services?.[index]?.cptCode;
    const hasDuplicatesError = currentErrorObj === 'CPT Code should be unique';
    const newCpt = [...services.slice(0, index), ...services.slice(index + 1)];

    await form.setFieldValue('ispConfiguration.services', newCpt);
    updateCpts(index);
    await updateErrors(index);

    if (hasDuplicatesError) {
      await updateDuplicatedErrors(newCpt, prevValue);
    }
  }, [backendErrors, updateCpts, updateErrors, updateDuplicatedErrors]);

  return (
    <div className={classes.tableItem}>
      <IconButton
        aria-label="delete"
        size="small"
        onClick={() => onDismiss(index, form)}
      >
        <RemoveIcon fontSize="small" />
      </IconButton>
    </div>
  );
};

CptEndCheckbox.propTypes = {
  form: PropTypes.object.isRequired,
  backendErrors: PropTypes.object,
  cpts: PropTypes.array.isRequired,
  setCpts: PropTypes.func.isRequired,
  setErrors: PropTypes.func.isRequired,
  validateField: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
};

export default React.memo(CptEndCheckbox);
